import { defineStore } from 'pinia';
import useQueueStore from '@/stores/manuscripts/queue';

const queueStore = useQueueStore({
  queueItemsPath: '/exports/',
  guidSearchParam: 'manuscript_id',
  queueItemIdField: 'export_id',
  queueItemIdFilterField: 'export_id',
  queueItemUpdateFields: [
    'title',
    'status',
    'has_data',
    'bulk_generation_id',
    'failure_count',
  ],
});

const useExportQueueStore = defineStore('manuscript-export-queue', queueStore);

export default useExportQueueStore;
